<template>
  <global-dialog-card
    v-model="model"
    :max-width="700"
    :title="canSeeStoredCredit ? $t('credit') : $t('add_credit')"
    :subtitle="company ? 'ID: ' + company.id : ''"
  >
    <template #title-actions>
      <v-btn text dark @click="editCredit()">
        {{ $t("edit_credit") }}
      </v-btn>
      <v-btn text dark @click="addNewCredit()">
        {{ $t("add_credit1") }}
      </v-btn>
    </template>

    <autocomplete
      v-if="canSeeStoredCredit"
      :label="$t('credit')"
      v-model="selectedCredit"
      :items="storedCredits"
      hide-details
      @change="selectCredit"
      item-value="id"
      item-text="name"
    ></autocomplete>

    <v-form v-if="canSeeInputFields" v-model="valid">
      <text-field
        v-model="creditForm.naziv"
        :label="$t('add_title')"
        :rules="[rules.required]"
        required
      />
      <v-row>
        <v-col>
          <v-switch
            v-model="creditForm.percent"
            inset
            hide-details
            :label="$t('percent')"
          ></v-switch>
        </v-col>
        <v-col>
          <text-field
            type="number"
            v-model="creditForm.rabat"
            :label="$t('add_rabat')"
            :rules="[rules.required]"
            required
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <date-picker
            v-model="creditForm.date_from"
            single-date
            :label="$t('inital_date')"
          />
        </v-col>
        <v-col>
          <date-picker
            v-model="creditForm.date_to"
            single-date
            :label="$t('ending_date')"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-switch
            v-model="creditForm.active"
            inset
            hide-details
            :label="$t('status')"
          ></v-switch>
        </v-col>
      </v-row>
    </v-form>

    <template #actions>
      <v-btn text @click="model = false">
        {{ $t("cancel") }}
      </v-btn>
      <primary-button @click="save()" :disabled="!canSeeInputFields || !valid">
        {{ $t("save") }}
      </primary-button>
    </template>
  </global-dialog-card>
</template>

<script>
import companyService from "@/services/company";
import hasSnackbar from "@/mixins/hasSnackbar";
import hasModel from "@/mixins/hasModel";
import hasValidation from "@/mixins/hasValidation";

export default {
  name: "CompanyCreditDialog",
  mixins: [hasSnackbar, hasModel, hasValidation],
  props: {
    company: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      canSeeStoredCredit: true,
      canSeeInputFields: false,
      selectedCredit: "",
      storedCredits: [],
      creditForm: {
        naziv: "",
        rabat: "",
        percent: "",
        date_from: null,
        date_to: null,
        active: "",
        date: "",
      },
    };
  },
  watch: {
    model(val) {
      if (val && this.company) {
        this.loadCredits();
        this.initializeForm();
      }
    },
    company: {
      handler(val) {
        if (val && this.model) {
          this.loadCredits();
          this.initializeForm();
        }
      },
      immediate: true,
    },
  },
  methods: {
    initializeForm() {
      if (this.company) {
        this.canSeeStoredCredit = true;
        this.canSeeInputFields = false;
        this.creditForm = {
          ...this.company,
          date_from: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
          date_to: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
        };
      }
    },
    editCredit() {
      this.canSeeStoredCredit = true;
      this.canSeeInputFields = false;
      this.selectedCredit = "";
      this.resetForm();
    },
    addNewCredit() {
      this.canSeeStoredCredit = false;
      this.canSeeInputFields = true;
      this.resetForm();
    },
    resetForm() {
      this.creditForm = {
        naziv: "",
        rabat: "",
        percent: "",
        date_from: null,
        date_to: null,
        active: "",
        date: "",
      };
    },
    selectCredit() {
      const selected = this.storedCredits.find((item) => item.id === this.selectedCredit);
      if (selected) {
        this.creditForm = { ...selected };
        this.canSeeInputFields = true;
      }
    },
    loadCredits() {
      if (!this.company?.id) return;

      companyService
        .getCredit(this.company.id)
        .then(({ data }) => {
          this.storedCredits = data;
        })
        .catch(() => {
          this.showErrorSnackbar(this.$t("error_loading_credits"));
        });
    },
    save() {
      companyService
        .saveCredit(this.creditForm)
        .then(({ data }) => {
          this.showSuccessSnackbar(this.$t("credit_saved"));
          this.$emit("saved", data);
          this.model = false;
        })
        .catch(() => {
          this.showErrorSnackbar(this.$t("error_saving_credit"));
        });
    },
  },
};
</script>
